import React from 'react';
import propTypes from 'prop-types';
import { TextField } from 'formik-material-ui';
import { Field } from 'formik';
import * as Yup from 'yup';

export const type = "text";
export const label = "Identifier";
export const defaultValue = null;
export const schema = Yup.string().nullable();

export default function ReactionOutputIdentifier({ namespace, className, ...props }) {

  return (
    <Field
      size='small'
      className={className}
      placeholder={label}
      component={TextField}
      name={namespace}
      type={type}
      disabled
      onClick={(ev) => ev.stopPropagation()}
    />
  );
}

ReactionOutputIdentifier.propTypes = {
  namespace: propTypes.string,
  className: propTypes.string,
}